<template>
  <div id="notification-pc">
    <div>&nbsp;</div>
    <div class="exp-title">{{ msg.notification.title }}</div>
    <div class="exp-text">{{ msg.notification.exp1 }}</div>
    <div class="exp-text">{{ msg.notification.exp2 }}</div>
    <div class="exp-text">{{ msg.notification.exp3 }}</div>
    <div class="exp-text">{{ msg.notification.exp4 }}</div>
    <div class="exp-text">{{ msg.notification.exp5 }}</div>
    <div class="exp-confium">
      <v-btn v-if="!isPermission" @click="clickPermission">
        <v-icon left>done_outline</v-icon>保存の許可</v-btn
      >
      <v-btn class="ml-4" @click="clickDisp">
        <v-icon left>exit_to_app</v-icon>許可しない
      </v-btn>
    </div>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
import WebStorage from "../../lib/webStorage.js";
import Util from "../../lib/util.js";
import mixin from "../../lib/mixin.js";

/**
 * 川の防災情報 PC用通知の説明ダイアログ
 * Notification.vue
 * @author LIS
 */
export default {
  name: "FirstExplanation",
  mixins: [mixin],
  data() {
    return {
      isPermission: false,
    };
  },
  computed: {
    /** メッセージ情報 */
    msg: {
      get() {
        return this.$store.state.app.config.messageConfig;
      },
    },
  },
  methods: {
    /**
     * 通知を許可クリック時
     */
    clickPermission() {
      this.$log.debug("[Notification] clickPermission()");
      // 初回アクセス説明を非表示に
      this.$store.commit("app/setShowNotification", false);
      this.isPermission = true;
      // トークンの取得を行う、この時にブラウザの通知許可が表示される
      this.initPwa();
    },
    clickDisp() {
      this.$log.debug("[Notification] clickDisp()");
      // 初回アクセス説明を非表示に
      this.$store.commit("app/setShowNotification", false);
      // 通知許可を押すことなく表示した場合はwebストレージに登録
      if (!this.isPermission) {
        WebStorage.setNotification({
          permission: false,
          date: Util.formatDate(Util.toDate()),
        });
        // ストアに通知許可なしを格納
        this.$store.commit("app/setPermission", false);
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss">
@import "../../scss/color.scss";

#notification-pc {
  position: absolute;
  z-index: 5020;
  width: 600px;
  height: 280px;
  top: 0;
  right: 0;
  background: $notification-back;
  color: $notification-text;
  border-color: $first-exp-text;
  font-size: 1.1rem;
  .exp-title {
    font-size: 1.5rem;
    text-align: center;
  }
  .exp-text {
    margin-left: 24px;
    word-break: break-all;
    white-space: pre-wrap;
  }
  .exp-confium {
    margin-top: 24px;
    text-align: center;
  }
}
</style>
